export default {
  title: 'מצטערים',
  error: 'אין מה לראות פה...',
  notFound: 'הדף שחיפשת לא קיים',
  link: {
    title: 'בחזרה לעמוד הראשי',
  },
};
